import {
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import {
  ReloadOutlined,
  FilterOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { HEADERS_EXPORT_BEN, POST_MAIN_CHANGE_JOBS } from "../../API/apiUrls";
import useLawyerNamesNew from "../../../hook/UseLawyerNameNew";
import axios from "axios";
import ApprovalRollback from "./modal/ApprovalRollback";

const Main = () => {
  const { nameLawyers, loadingUseLawyerNames } = useLawyerNamesNew({
    auto: true,
    toast: false,
  });
  const userId = parseInt(localStorage.getItem("USER_ID"));

  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState("");

  const [dataRecord, setDataRecord] = useState();
  const [isModal, setIsModal] = useState(false);

  // ── Lawyer options ────────────────────────────────────────
  const lawyerOptions = (nameLawyers ?? [])
    .filter(
      (l) => l.ACTIVE_STATUS === 1 && l.COMPANY_ID !== 3 && l.ROLE_ID === 3,
    )
    .map((l) => ({ label: l.NNAME ?? l.NAME1, value: l.id ?? l.userId }));

  // ── Load ──────────────────────────────────────────────────
  const loadMainData = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        POST_MAIN_CHANGE_JOBS,
        { userId: 1 },
        { headers: HEADERS_EXPORT_BEN },
      );
      if (res.status === 200) {
        if (res.data.success === "ไม่พบข้อมูล") {
          message.warning("ไม่พบข้อมูล");
          return;
        }

        const ALLOWED_STATUS = [1, 2, 3, 6, 7];

        const useData = (res.data?.data ?? [])
          .filter((item) => ALLOWED_STATUS.includes(item.currentStatus))
          .map((item, i) => ({ ...item, key: i + 1 }));

        setArrayTable(useData);
        setDataArr(useData);
      } else {
        message.error("ไม่มีข้อมูล");
        setArrayTable([]);
        setDataArr([]);
      }
    } catch (err) {
      console.error(err);
      message.error(`ไม่พบข้อมูล: ${err.message}`);
      setArrayTable([]);
      setDataArr([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMainData();
  }, []);

  // ── Filter ────────────────────────────────────────────────
  const handleFilterData = () => {
    setLoading(true);
    const q = searchInputTable.trim().toLowerCase();
    const result = (dataArr ?? []).filter(
      (item) =>
        !q ||
        [item.CUSCOD, item.CONTNO, item.NAME1, item.NAME2]
          .map((v) => String(v ?? "").toLowerCase())
          .some((val) => val.includes(q)),
    );
    setArrayTable(result);
    setTimeout(() => setLoading(false), 250);
    result.length === 0
      ? message.error("ไม่พบข้อมูล")
      : message.success(`พบข้อมูล ${result.length} รายการ`);
  };

  const confirmAcceptWork = (record) => {
    console.log("confirmAcceptWork", record);

    setDataRecord(record);
    setIsModal(true);
  };

  const handleLoad = (data) => {
    console.log(data);
    loadMainData();
  };

  // ── Columns ───────────────────────────────────────────────
  const columns = [
    {
      title: "ลำดับ",
      align: "center",
      width: "10%",
      render: (_, __, idx) => idx + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "CONTNO",
      align: "center",
      width: "15%",
    },
    {
      title: "ชื่อ-นามสกุล",
      align: "left",
      width: "20%",
      render: (_, r) =>
        `${r.SNAM ?? ""}${r.NAME1 ?? ""} ${r.NAME2 ?? ""}`.trim(),
    },
    {
      title: "สถานะ",
      align: "center",
      width: "15%",
      render: (_, r) => (
        <Tag color="blue">{r.mainStatusDescription ?? "-"}</Tag>
      ),
    },
    {
      title: "ผู้รับผิดชอบ",
      align: "center",
      width: "20%",
      render: (_, r) => {
        return (
          <Select
            value={r.userId}
            style={{ width: 150 }}
            loading={loadingUseLawyerNames}
            disabled={true} // ✅ disable ถ้าแถวนี้ไม่ได้แก้ไข
            options={lawyerOptions}
          />
        );
      },
    },
    {
      title: "การจัดการ",
      align: "center",
      width: "20%",
      render: (_, r) => {
        return (
          <Button
            size="small"
            icon={<RollbackOutlined />}
            onClick={() => confirmAcceptWork(r)}
          >
            คืนงงาน
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Card style={{ marginBottom: 12 }}>
        <Space>
          <Input
            placeholder="ค้นหาสัญญา / ชื่อ / เลขบัตร"
            value={searchInputTable}
            onChange={(e) => setSearchInputTable(e.target.value)}
            onPressEnter={handleFilterData}
            style={{ width: 260, borderRadius: 8 }}
            allowClear
          />
          <Button
            icon={<FilterOutlined />}
            onClick={handleFilterData}
            disabled={dataArr.length === 0}
            style={{
              borderRadius: 8,
              backgroundColor: "#fff7d6",
              border: "1px solid #ffe58f",
            }}
          >
            กรองข้อมูล
          </Button>
          <Button
            icon={<ReloadOutlined />}
            onClick={() => {
              setSearchInputTable("");
              setArrayTable(dataArr);
            }}
            disabled={dataArr.length === 0}
          >
            ล้าง
          </Button>
          <Button
            icon={<ReloadOutlined />}
            type="primary"
            ghost
            onClick={loadMainData}
            loading={loading}
          >
            โหลดใหม่
          </Button>
        </Space>
      </Card>

      <Card>
        <Spin spinning={loading} size="large" tip="Loading...">
          <Table
            size="small"
            columns={columns}
            dataSource={arrayTable}
            rowKey={(r) => r.loanId ?? r.key}
            scroll={{ x: "max-content" }}
            pagination={{
              defaultPageSize: 20,
              showSizeChanger: true,
              showTotal: (t) => `ทั้งหมด ${t} รายการ`,
            }}
            footer={() => (
              <span>จำนวนสัญญาทั้งหมด {arrayTable.length} รายการ</span>
            )}
          />
        </Spin>
      </Card>

      {isModal && (
        <ApprovalRollback
          open={isModal}
          close={setIsModal}
          record={dataRecord}
          handleLoad={handleLoad}
        />
      )}
    </>
  );
};

const MainRollbackJobsLawyers = MotionHoc(Main);
export default MainRollbackJobsLawyers;
